<template>
  <LibraryListItem>
    <DocumentScoreLink
      :id="document.id"
      :score="document.score_total_capped"
      class="ml-5"
    />
    <PostTitleCompanyBadgesCell
      :title="document.title"
      :company="document.company"
      :is-external="document.is_external"
      :is-evergreen="document.is_evergreen"
    />

    <div
      v-if="!document.days_published || document.days_published <= 120"
      class="days-published-container"
    >
      <span :class="{ 'no-data': !document.days_published }">
        {{ document.days_published }}
      </span>
    </div>
    <div
      v-else-if="document.days_published > 120"
      class="days-published-container"
    >
      <DpplDarkTooltip
        tooltip-placement="left"
        :tooltip-offset="12"
        light-mode
      >
        <template #activator="{ onMouseenter, onMouseleave }">
          <div
            class="d-flex align-center"
            @mouseenter="onMouseenter"
            @mouseleave="onMouseleave"
          >
            <div
              class="mr-1 days-published"
              :class="{ 'no-data': !document.days_published }"
            >
              {{ document.days_published }}
            </div>
            <v-icon
              color="error"
              size="14px"
              icon="$information-outline"
            />
          </div>
        </template>
        <template #tooltip-content>
          <div class="tooltip-content">
            <span class="mr-1">This job has been open for too long and should be reposted.</span>
            <br>
            <a
              href="#"
              data-beacon-article-sidebar="66a909140d7d86166241f9b4"
              class="read-more"
              @click.stop
            >Read more here.
            </a>
          </div>
        </template>
      </DpplDarkTooltip>
    </div>
    <PostReqIdCell
      :req-uuid="document.req_uuid"
      :ats-req-id="document.ats_requisition_id"
      :flexible-id="document.flexible_id"
      @library-req-report-track="emits('library-req-report-track', document)"
    />
    <PostLocationCell :location="document.location" />
    <PostDepartmentCell
      v-if="integrated"
      :ats-department-name="document.ats_department_name"
    />
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import PostTitleCompanyBadgesCell from '@/components/library/listItemCells/PostTitleCompanyBadgesCell.vue';
import PostReqIdCell from '@/components/library/listItemCells/PostReqIdCell.vue';
import PostLocationCell from '@/components/library/listItemCells/PostLocationCell.vue';
import PostDepartmentCell from '@/components/library/listItemCells/PostDepartmentCell.vue';
import DpplDarkTooltip from '@/components/datapeople/DpplDarkTooltip.vue';
import DocumentScoreLink from '@/components/shared/DocumentScoreLink.vue';

defineProps({
  document: {
    type: Object,
    required: true,
  },
  integrated: {
    type: Boolean,
    required: true,
  },
});

const emits = defineEmits(['library-req-report-track']);
</script>

<style lang="less" scoped>
.days-published-container {
  max-width: 100%;

  :deep(.days-published) {
    font-size: 13px;
    font-weight: 500;
  }
}

:deep(.tooltip-content) {
  font-size: 13px;
  font-weight: 500;
  color: @text-light;
  text-align: center;
}
</style>
